import clsx from "clsx";
import { useSelector } from "react-redux";
import { hotspotSize } from "../../config";
import "../../index.css";
import {
  getCurrentFrameIndex,
  getCurrentHotspot,
  getCurrentLayer,
  getCurrentStep,
  getHotspotIndexOfHoverMessageShown,
  getHoverActionTooltipContent,
  getHoverActionTooltipStyle,
  getPointer,
} from "../../redux/selectors";
import { steps } from "../../util/constants";
import { htmlToReactDangerousInnerHTML } from "../../util/general";

export function HotspotTooltip() {
  const currentHotspot = useSelector(getCurrentHotspot);
  const hotspotIndexOfHoverMessageShown = useSelector(
    getHotspotIndexOfHoverMessageShown
  );
  const hotspotIndex = currentHotspot ?? hotspotIndexOfHoverMessageShown;
  const currentStep = useSelector(getCurrentStep);
  const frame = useSelector(getCurrentFrameIndex);
  const layer = useSelector(getCurrentLayer);
  const pointer = useSelector((state) =>
    getPointer(state, layer, frame, hotspotIndex)
  );
  const html = useSelector((state) =>
    getHoverActionTooltipContent(state, { hotspotIndex })
  );
  const tooltipStyle = useSelector((state) =>
    getHoverActionTooltipStyle(state, { hotspotIndex })
  );

  if (!html?.length) {
    return <></>;
  }
  if (!pointer) {
    return null;
  }
  if (![steps.configureHoverAction, steps.preview].includes(currentStep)) {
    return null;
  }

  const tooltipActive = hotspotIndex === hotspotIndexOfHoverMessageShown;
  if (!tooltipActive) {
    return null;
  }

  const style = {
    position: "absolute",
    left: `${pointer.x}%`,
    top: `calc(${pointer.y}% - ${hotspotSize[1] / 2}px`,
    width: "max-content",
    maxWidth: "20em",
  };
  const baseClassName = "sirv-hotspot-tooltip sirv-hotspot-tooltip-visible";
  const className = clsx(baseClassName, tooltipStyle);

  return (
    <div
      draggable="false"
      className={className}
      style={style}
      dangerouslySetInnerHTML={htmlToReactDangerousInnerHTML(html)}
    />
  );
}
